import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { interval } from 'rxjs';
import { SimilarCandidateDetails } from '../common-interfaces-classes/SimilarCandidate';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { SimilarCandidateFilterComponent } from '../similar-candidate-filter/similar-candidate-filter.component';
import { PersonSearchService } from '../_services/person-search.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';


export type SCPassData = { data: SimilarCandidateDetails, calledfrom: string };

@Component({
    selector: 'app-ai-modal-sc',
    templateUrl: './ai-modal-sc.component.html',
    styleUrls: ['./ai-modal-sc.component.scss'],
    standalone: false
})
export class AiModalScComponent implements OnInit {

  progressValue = 0;
  @Input() public similarCandidateData : SCPassData;

  constructor(private activeModal: NgbActiveModal, private similarCandidateService: SimilarCandidateService,
    private modalService: NgbModal, private personSearchService: PersonSearchService, private location: Location, private router: Router) { }

  ngOnInit() { this.increaseProgress(); }

  private increaseProgress() {
    const interval$ = interval(1000);
    const subscription = interval$.subscribe(() => {
      this.progressValue += 20;
      if (this.progressValue > 100) {
        subscription.unsubscribe();
        this.activeModal.close(this.similarCandidateData);
        this.modalService.dismissAll();
      //  this.editSimilarCandidateFilters(true);

        // We don't need to emit this event if we are coming from listing page

      }
    });
  }

//          editSimilarCandidateFilters(firstLoad = false) {

//             this.personSearchService.passsimilarcandidatesdata({
//               ...this.similarCandidateData,
//               calledfrom: 'edit-similar-candidate'
//             });
//             if(this.similarCandidateData?.data?.jobtitle?.length > 0) {
//              this.personSearchService.passsimilarcandidatesdata(this);
//  this.similarCandidateData.calledfrom !== "view-similar-candidate" && this.similarCandidateService.emitSimilarCandidateObsEvent(this.similarCandidateData);

//      this.router.navigate(['/person/search/listing'], { queryParams: { type: this.similarCandidateData.calledfrom } });

//             } else {
//             const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false });
//             const modalInstance: SimilarCandidateFilterComponent = modalRef.componentInstance;
//             modalInstance.type = "edit";
//             modalRef.result.then((res) => {
//        if (res.action == 'submit') {
//                 this.personSearchService.passsimilarcandidatesdata(res);
//  this.similarCandidateData.calledfrom !== "view-similar-candidate" && this.similarCandidateService.emitSimilarCandidateObsEvent(res);

//      this.router.navigate(['/person/search/listing'], { queryParams: { type: this.similarCandidateData.calledfrom } });

//               } else if (res.action === 'close' && firstLoad) {
//                 this.location.back();
//               }
//               modalRef.dismiss();
//             });
//            // }



//           }
//         }

}
